import { db } from "../firebase/config";
import { collection, doc, addDoc, updateDoc, onSnapshot } from "firebase/firestore";

export function subscribeToShipments(callback) {
  return onSnapshot(collection(db, "logistics"), (snapshot) => {
    const list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });
    list.sort((a, b) => (b.poNumber || "").localeCompare(a.poNumber || ""));
    callback(list);
  }, (error) => {
    console.error("Error subscribing to logistics:", error);
    callback([], error);
  });
}

export async function addShipment(shipmentData) {
  const docRef = await addDoc(collection(db, "logistics"), shipmentData);
  return docRef.id;
}

export async function updateShipment(id, shipmentData) {
  const docRef = doc(db, "logistics", id);
  await updateDoc(docRef, shipmentData);
}

export function subscribeToCarriers(callback) {
  return onSnapshot(collection(db, "carriers"), (snapshot) => {
    let list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });
    if (list.length === 0) {
      callback([{ id: "mock1", name: "FedEx Freight" }, { id: "mock2", name: "UPS Supply Chain" }, { id: "mock3", name: "DHL Express" }, { id: "mock4", name: "Maersk Line" }]);
    } else {
      list.sort((a, b) => a.name.localeCompare(b.name));
      callback(list);
    }
  }, (error) => {
    console.error("Error subscribing to carriers:", error);
    callback([], error);
  });
}
